import classNames from 'classnames/bind'
import { useGetCareerDescription } from '../data-access-career-description'
import LearningObjectives from '../ui-learning-objectives'
import styles from './CareerDescription.module.scss'

const cx = classNames.bind(styles)

type CareerDescriptionProps = {
  slug?: string
}

const CareerDescription = ({ slug }: CareerDescriptionProps) => {
  const { loading, careerDescription } = useGetCareerDescription(slug)

  if (loading) {
    return null
  }

  return (
    <div className={cx('container')}>
      <div className={cx('objectives')}>
        <LearningObjectives {...careerDescription.learningObjectivesData} />
      </div>
    </div>
  )
}

export default CareerDescription
